import { render, staticRenderFns } from "./product-stock-availability-child.vue?vue&type=template&id=7570cdff&scoped=true"
import script from "./product-stock-availability-child.vue?vue&type=script&lang=js"
export * from "./product-stock-availability-child.vue?vue&type=script&lang=js"
import style0 from "./product-stock-availability-child.vue?vue&type=style&index=0&id=7570cdff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7570cdff",
  null
  
)

export default component.exports